import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'lz-bookmark-tree-view',
  template: `<div class="tree-element" *ngFor="let item of folders">
  <i class="fa" [ngClass]="{'fa-minus-square-o': item.isActive, 'fa-plus-square-o': !item.isActive}" (click)="toogleFolder(item)"
    *ngIf="item.subFolders && item.subFolders.length > 0">
  </i>
  <span (click)="chooseFolder(item)">{{item.name}}</span>
  <lz-bookmark-tree-view (outputEvent)="chooseFolder($event)" *ngIf="item.subFolders && item.subFolders.length > 0 && item.isActive"
    [folders]="item.subFolders"></lz-bookmark-tree-view>
</div>
`,
  styles: [`.lz-pl-container{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container{width:732px;padding:0}}@media (min-width:1002px){.lz-pl-container{width:976px}}@media (min-width:1490px){.lz-pl-container{width:1440px}}.lz-pl-container-new{position:relative;display:block;margin-left:auto;margin-right:auto;padding:0 12px}@media (min-width:758px){.lz-pl-container-new{width:732px;padding:0}}@media (min-width:1200px){.lz-pl-container-new{width:1200px}}@media (min-width:1490px){.lz-pl-container-new{width:1440px}}.modal-lg{width:900px}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}*{text-shadow:none!important}body,h1,h2,h3,h4,h5,h6,ol,p,ul{margin:0;padding:0;font-weight:400}ol,ul{list-style:none}img{max-width:100%;height:auto;vertical-align:middle}.h1,.h2,.h3,.h4,.h5,.h6,button,h1,h2,h3,h4,h5,h6,input,p,textarea{font-family:inherit;font-size:inherit;font-weight:inherit}input:focus,textarea:focus{outline:0}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{line-height:1.1}fieldset{border:none}.tree-element{font-family:Geometria,Arial,sans-serif;position:relative;padding:0 0 0 20px;line-height:20px;text-overflow:ellipsis;overflow-x:hidden;white-space:nowrap}.tree-element i{position:relative;top:1px;padding:0;cursor:pointer;margin-left:-13px}.tree-element span{margin-left:5px;font-size:13px;color:#555;cursor:pointer}`]
})

export class LzBookmarkTreeView {

  @Input()
  folders: any = [];

  @Output('outputEvent')
  outputEvent = new EventEmitter < string > ();

  constructor() {
    for (let i = 0, ilen = this.folders.length; i < ilen; i += 1) {
      this.folders[i].isActive = false;
    }
  }

  public toogleFolder = (folder) => {
    folder.isActive = (folder.isActive) ? false : true;
  }

  chooseFolder = (item) => {
    this.outputEvent.emit(item);
  }

}
